import { get } from 'lodash'
import { graphql } from 'gatsby'
import React from 'react'

import { Base, Footer, Navigation } from 'components/common'
import PlayTherapyTemplate from 'templates/play-therapy-page'

const getNode = obj => get(obj, 'edges.0.node', {})

export default function PlayTherapyPage({ data = {} }) {
  const { html, frontmatter: pageContent } = getNode(data.content)
  const { frontmatter: globals } = getNode(data.globals)

  const {
    footer,
    navigation,
  } = globals

  const { phoneNumber } = footer

  return (
    <Base>
      <Navigation {...navigation} phoneNumber={phoneNumber} />
      <PlayTherapyTemplate content={html} {...pageContent} />
      <Footer {...footer} />
    </Base>
  )
}

export const pageQuery = graphql`
query PlayTherapyPageQuery {
  globals: allMarkdownRemark(
    filter: { frontmatter: { templateKey: { eq: "globals" } }}
  ) {
    edges {
      node {
        frontmatter {
          accreditations {
            alt
            image {
              childImageSharp {
                fluid(maxWidth: 400, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          footer {
            logo {
              childImageSharp {
                fluid(maxWidth: 400, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            emailAddress
            phoneNumber
          }
          navigation {
            logo {
              alternativeText
              image {
                childImageSharp {
                  fluid(maxWidth: 400, quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            pages {
              label
              path
            }
          }
        }
      }
    }
  }

  content: allMarkdownRemark(
    filter: { frontmatter: { templateKey: { eq: "play-therapy-page" } }}
  ) {
    edges {
      node {
        html
        frontmatter {
          heroBottomHeading
          heroTopHeading
          heroTopImage {
            childImageSharp {
              fluid(maxWidth: 1200, quality: 80) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
}
`
